export default __webpack_public_path__ + "static/media/4.03c75df9.jpg";